module.exports = __webpack_public_path__ + "img/cb-bg.7bb82b3b.png";